import PropTypes from 'prop-types';
import React from 'react';
import { Button,ButtonToolbar, Modal } from 'react-bootstrap';

class ManageBidEditMamber extends React.Component {
	constructor(props) {
    	super(props);

    	const memersDates =[];
    	const bidDetailIds =[];
        this.props.members.forEach((val)=>{
            if(val.bidDetail>0){
                bidDetailIds.push(val.bidDetail)
            }
            let data = memersDates.find(bd => bd.checkIn == val.check_in_date && bd.checkOut == val.check_out_date)
            if(data){
                data.member++
            }else{
                let count = memersDates.length;
                memersDates.push({
                    'id':count,
                    'member':1,
                    'checkIn':val.check_in_date,
                    'checkOut':val.check_out_date,
                })
            }

        })

    	this.state={
    		memersDates,
    		bidDetailIds,
    		show:false,
    		selectedDate:null,
    		selectedCheckIn:null,
    		selectedCheckOut:null,
    		showForm:false,
    		editMembers:null,
    		members:0,
    		checkIn:null,
    		checkOut:null,
    		group_id:null,
    		disable:false,
    		warning:false,
    		rooms :{'suite':0,'king':0,'double':0},
    	}
    	this.addDate = this.addDate.bind(this);
    	this.closePopUp = this.closePopUp.bind(this);
    	this.onCloseWarning = this.onCloseWarning.bind(this);
    	this.changeMembers = this.changeMembers.bind(this);
    	this.changeDates = this.changeDates.bind(this);
        this.roomtypeOption = this.roomtypeOption.bind(this);
        this.submitNewDates = this.submitNewDates.bind(this);
    }
    closePopUp(){
    	this.props.closeChangeDatePopUp();
    	this.setState({
    		showForm:false,
    		selectedDate:null,
    	})
    }
    onCloseWarning(){
    	this.setState({warning:false})
    }
    changeMembers(e){
    	this.setState({
    		members:e.target.value,
            disable:false,
    	})
    }
    changeDates(e){
    	let name = e.target.name;
    	if(name =='checkInDate'){
    		this.setState({
    			checkIn:e.target.value,
                disable:false,
    		})
    	} else{
    		this.setState({
    			checkOut:e.target.value,
                disable:false,
    		})
    	}
    }
   	addDate(val){
    	if(val.id!=this.state.selectedDate){
    		let count = 0;
    		let group = 0;
    		this.props.members.forEach((bid)=>{
    			group = bid.group_id;
    			if(val.checkIn == bid.check_in_date && val.checkOut == bid.check_out_date){
    				count = count+1
    			}
    		})

    		this.setState({
    			selectedDate:val.id,
    			showForm:true,
    			selectedCheckIn:val.checkIn,
    			selectedCheckOut:val.checkOut,
    			editMembers:count,
    			members:count,
    			checkIn:val.checkIn,
    			checkOut:val.checkOut,
    			group_id:group,
                disable:true,
                rooms :{'suite':0,'king':0,'double':0},

    		})
    	}
    }
    roomtypeOption(e){
        const nameVal = e.target.name;
        const value = parseInt(e.target.value);
        const name = nameVal== 'suite'?'suite':nameVal== 'king'?'king':nameVal== 'double'?'double':false;
        const data = this.state.rooms;
        data[name] = value;
        this.setState({
            rooms:data,
            disable:false,
        })
    }
    submitNewDates(){
    	const rooms = this.state.rooms;
        const roomCount = rooms.suite+rooms.king+rooms.double;
        if(roomCount>this.state.members){
            this.setState({ warning: true, text:"The Number of room types cannot exceed the number of entered in participant section. Please correct this in order to continue."})
            return false;
        }
    	if(this.state.members== 0){
    		this.setState({ warning: true, text:"Please enter Valid Participants number"})
    		return false;
    	}
    	if(this.state.members>this.state.editMembers){
    		this.setState({ warning: true, text:"Please enter Valid Participants number. The participant's number should not greater than the existing Participants, which have same Check-In/Out date."})
    		return false;
    	}
    	if (this.state.checkIn==this.state.selectedCheckIn && this.state.checkOut==this.state.selectedCheckOut){
    		this.setState({ warning: true, text: "Please enter a valid check-in/out date. check-In/Out date should be Different than the existing date." });
    		return false;
    	}
    	if(this.state.checkOut<this.state.checkIn){
    		this.setState({ warning: true, text: "Please enter a valid check-in/out date. check-in date should be earlier than the check-out date." });
    		return false;
    	}
    	const event_id = this.props.event.id;
    	const payload = {
    		'old_check_in':this.state.selectedCheckIn,
    		'old_check_out':this.state.selectedCheckOut,
    		'total_members':this.state.editMembers,
    		'bid_data':[],
    		'bid_detail':this.state.bidDetailIds,
    		'tour_id':this.props.tourId,
    		'event_id':event_id,
    		'group':this.state.group_id,
    		'new_members':this.state.members,
    		'new_check_in':this.state.checkIn,
    		'new_check_out':this.state.checkOut,
    		'room_data': this.state.rooms
    	};
    	this.closePopUp();
    	this.props.changeDateRoomType(payload,(response)=>{
    		let data ={'bid_detail':response.bid_detail}
    		this.props.updateBidData(data);
            this.props.changeBidData();
            this.setState({
                showForm:false,
                disable:false,

            })
    	})
    }
    render(){
    	const margin ={'marginRight':'3%','width': '20%'};
    	return(
    	  <div>
    	  	<Modal show={this.props.showChangeDate} onHide={this.closePopUp}>
    	  	   <Modal.Header closeButton>
    			  <Modal.Title>Bulk change Check In/Out Dates</Modal.Title>
    			</Modal.Header>
    			<Modal.Body>
    				<h4>Change Check-In/Out date</h4><br/>
    				<div className="row">
    					{this.state.memersDates.map((val) =>(
    						<div className="col-sm-6 col-md-6" key={val.id}>
    							<input type="radio" checked={this.state.selectedDate==val.id?true:false} onChange={()=>this.addDate(val)}/>&nbsp;<span>{val.checkIn+' To '+val.checkOut}</span><br/>
                                <span>members :{val.member}</span>
    						</div>
    					))}
    				</div>
    				{this.state.showForm && (
    					<div><br/>
    						<p>These are {this.state.editMembers} participants who have the {this.state.selectedCheckIn+' To '+this.state.selectedCheckOut} Check-In/Out date.</p><br/>
    						No of Participants:
    						<input type="text" name="members" className="form-control" value={this.state.members} onChange={this.changeMembers} required/><br/> 
    						Check In Date:
    						<input type="date" name="checkInDate" className="form-control" value={this.state.checkIn} onChange={this.changeDates} max={ "9999-12-31" } required/><br />
    						Check Out Date:
    						<input type="date" name="checkOutDate" className="form-control" value={this.state.checkOut} onChange={this.changeDates} max={ "9999-12-31" } required/><br/><br/>
                                
                            <p>Please add room types, if you want to change room type to these {this.state.members} members.</p><br/><hr/>
                                <div><br/><br/>
                                   <label>Suite:</label>&nbsp;<input type="number" name="suite" size="20" onChange={this.roomtypeOption} style={margin} />
                                   <label>King:</label>&nbsp;<input type="number" name="king" size="20" onChange={this.roomtypeOption} style={margin}/>
                                   <label>Double:</label>&nbsp;<input type="number" name="double" size="20" onChange={this.roomtypeOption} style={margin}/><br/><br/>
                                </div>
                            <hr/>
                            <ButtonToolbar style={{ float: 'right' }}>
                			    <Button
                  				    bsStyle="success"
                                    disabled={this.state.disable}
                  					onClick={this.submitNewDates}
                				>Apply</Button>
              				</ButtonToolbar><br/>
    					</div>
    				)}
    			</Modal.Body>
    			<Modal.Footer style={{ clear: 'both' }} />
    	  	</Modal>
    	  	{this.state.warning && (
    				<Modal show={this.state.warning} onHide={this.onCloseWarning}>
          				<Modal.Header closeButton>
            				<Modal.Title>Error</Modal.Title>
          				</Modal.Header>
          				<Modal.Body>
							<p> {this.state.text}</p>
            				<ButtonToolbar style={{ float: 'right' }}>
              					<Button
                					bsStyle="success"
                					onClick={this.onCloseWarning}
              					>
                				Ok
                          		</Button>
            				</ButtonToolbar>
          				</Modal.Body>
         	 			<Modal.Footer style={{ clear: 'both' }} />
        			</Modal>
        		)}
    	  </div>
    	);
    }
}

export default ManageBidEditMamber;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBidEditMamber.js